var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerFireExtinguisherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#CC0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 9,
    width: 6.8,
    height: 10.4,
    rx: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 6.7,
    width: 3.2,
    height: 2.6,
    rx: 0.6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 5.1,
    width: 6.1,
    height: 1.7,
    rx: 0.85,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 6 q3.1 0.4 3.1 3.3",
    fill: "none",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 12.3,
    width: 6.8,
    height: 1.4,
    fill: "#CC0000",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFireExtinguisherIcon);
export default __webpack_public_path__ + "static/media/marker-fire-extinguisher-icon.44ffd93ab43dc79cb372c7b62164a118.svg";
export { ForwardRef as ReactComponent };